import { useEffect } from "react";
import TabContainer from "../tab/containers/tab.containers";
import { AgentAssignComponents } from "./agent-assigning.component";
import AgentMapTrackerComponent from "./agent-track-map.component";
import { useAppDispatch } from "../../../hooks/hooks";
import { agentLocationTrackers } from "../../../redux/agent-location-tracker/action";
import { useSelector } from "react-redux";
import { selectAgentLocationTrackersListItems } from "../../../redux/agent-location-tracker/selector";


export const AgentAssign = ({
    transportAgents,
    onFormChange,
    selectedValue,
    Shippinglocation,
}: any) => {
    const dispatch = useAppDispatch()
    const agentTrack = useSelector(selectAgentLocationTrackersListItems)
    const tabItems = [
        {
            id: 1,
            title: 'Agent Assign',
            component: <AgentAssignComponents
                transportAgents={transportAgents}
                onFormChange={onFormChange}
                selectedValue={selectedValue} />,
            isVisible: true,
        },

        // {
        //     id: 3,
        //     title: 'Agent tracker Info',
        //     component: <AgentMapTrackerComponent
        //         Shippinglocation={Shippinglocation}
        //         agentTrack={agentTrack?.result?.items}
        //     />,
        //     isVisible: true,
        // },
    ]
    useEffect(() => {
        dispatch(agentLocationTrackers.list({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/agent-location-tracker/list`, entity: 'agents', jsonData: {

            }
        }))

    }, [])

    return (
        <div className="flex flex-col items-center p-2 w-full h-[350px]">


            <TabContainer tabItems={tabItems} />

        </div>
    );
};
